import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StockService } from '@services/stock.service';
import { GlobalService } from '@services/global.service';  // ← AJOUT
import { Product, Banner } from '@models/product';
import { Depot, Stock } from '@models/stock';

@Component({
  selector: 'gob-product-stock',
  templateUrl: './product-stock.component.html',
  styleUrls: ['./product-stock.component.css']
})
export class ProductStockComponent implements OnInit, OnChanges {  // ← OnChanges ajouté
  @Input() product: Product;
  @Input() stockRight: boolean;
  loading: boolean = false;
  depots: Depot[] = [];
  banners: Banner[] = [];  // ← AJOUT : liste complète des bannières

  constructor(
    private stockServ: StockService,
    private gServ: GlobalService  // ← AJOUT
  ) {
    this.loading = true;

    this.stockServ.getDepots().subscribe((depots: any[]) => {
      this.depots = depots;
      this.loading = false;
    });

    // Chargement des bannières pour identifier celles de type "précommande"
    this.gServ.getClassification().subscribe(classes => {
      this.banners = classes.banners;
      this.syncReleaseDate();  // sync au cas où le produit est déjà chargé
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      this.syncReleaseDate();
    }
  }

  /**
   * Vérifie si une bannière (par ident) est de type précommande
   */
  isPrecoBanner(ident: string): boolean {
    const found = this.banners.find(b => b.ident === ident);
    return found?.name?.toLowerCase().includes('précommande') ?? false;
  }

  /**
   * Retourne la 1ère bannière précommande affectée au produit, ou undefined
   */
  getPreorderProductBanner(): any {
    if (!this.product?.banners?.length || !this.banners.length) return undefined;
    return this.product.banners.find(pb => this.isPrecoBanner(pb.ident));
  }

  /**
   * Indique si le produit a une bannière précommande
   */
  hasPreorderBanner(): boolean {
    return !!this.getPreorderProductBanner();
  }

  /**
   * Synchronise releaseDate = date fin bannière précommande + 1 jour
   */
  syncReleaseDate(): void {
    const precoBanner = this.getPreorderProductBanner();
    if (precoBanner && precoBanner.end) {
      const endDate = new Date(precoBanner.end);
      endDate.setDate(endDate.getDate() + 1);
      this.product.releaseDate = endDate.toISOString().split('T')[0];
    }
  }

  // ... reste inchangé
  getDepot(ident: string) {
    return this.depots.find(depot => depot.ident == ident);
  }

  addMissing() {
    let stock: Stock = new Stock();
    if (this.getDepotList().length)
      stock.depot = this.getDepotList()[0].ident;
    this.product.stocks.push(stock);
  }

  addAll() {
    if (this.getDepotList().length)
      this.getDepotList().forEach(depot => {
        let stock: Stock = new Stock();
        stock.depot = depot.ident;
        this.product.stocks.push(stock);
      });
  }

  getDepotList() {
    let results: Depot[] = [];
    this.depots.forEach(depot => {
      if (!this.product.stocks.find(stock => stock.depot == depot.ident))
        results.push(depot);
    });
    return results;
  }
}